import { useContext, useEffect, useState } from 'react';
import { UserContext } from '@namespace/user';
import { getDepositCryptoAddress } from '../../api/cryptocurrencies';
import { DepositCryptoAddress } from '../../api/cryptocurrencies/types';
import { STORE_PROPS, usePaymentsStore } from '../../store';

const { ACTIVE_SERVICE_ID } = STORE_PROPS;

export const useGetDepositCryptoAddress = (
  cryptoCurrency: string,
  fiatCurrency: string
) => {
  const [user] = useContext(UserContext);
  const { id } = user;
  const serviceId = usePaymentsStore(ACTIVE_SERVICE_ID);
  const [address, setAddress] = useState<DepositCryptoAddress>(
    {} as DepositCryptoAddress
  );

  useEffect(() => {
    (async () => {
      const queryParams = {
        cryptoCurrency,
        fiatCurrency,
        userId: id,
        serviceId: serviceId as number
      };
      try {
        const addressResponse = await getDepositCryptoAddress(queryParams);
        setAddress(addressResponse || '');
      } catch (e) {
        console.error(e);
      }
    })();
  }, [cryptoCurrency, fiatCurrency, id, serviceId, setAddress]);

  return address;
};
